<template>
  <div class="popup-overlay" @click.self="close">
    <div class="popup-content">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineEmits, onMounted, onBeforeUnmount } from 'vue';

const emit = defineEmits(['close']);

const close = () => {
  emit('close');
};

// Disable scrolling when the popup is mounted and re-enable when it's unmounted
onMounted(() => {
  if (process.client) {
    document.body.style.overflow = 'hidden';
  }
});

onBeforeUnmount(() => {
  if (process.client) {
    document.body.style.overflow = '';
  }
});
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup-content {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
  width: 80%;
  max-width: 580px;
}

</style>
